import React from "react";
import { Dispatch } from "redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import CreateTeamWorkflow from "./CreateTeamWorkflow";
import { MetricsState, selectors } from "../logging";
import ErrorBoundary from "../common/ErrorBoundary";
import "./createTeam.module.css";
import "../common/loader.module.css";
import { RootState } from "../redux/rootReducer";
import teamFormSchema from "../common/schema/teamFormSchema";
import bannerSlice, { DisplayBanner } from "../banner/bannerSlice";

interface CreateTeamProps {
  parentTeamId: string;
}

interface CreateTeamDispatchProps {
  setBanner: (banner: DisplayBanner | undefined) => void;
}

interface CreateTeamStateProps {
  metrics: MetricsState;
  displayBanner: DisplayBanner | undefined;
}

type CreateTeamPageProps = CreateTeamStateProps &
  CreateTeamDispatchProps &
  RouteComponentProps<CreateTeamProps>;

const CreateTeamPage: React.FC<CreateTeamPageProps> = ({
  metrics,
  match,
  displayBanner,
  setBanner,
}): JSX.Element => {
  // extract props from matched parameters
  const { parentTeamId } = match.params;
  const schema = teamFormSchema;
  const context = {
    metrics,
    parentTeamId,
    schema,
    displayBanner,
    setBanner,
  };

  return (
    <ErrorBoundary>
      <CreateTeamWorkflow workflowContext={context} />
    </ErrorBoundary>
  );
};

const mapStateToProperties = (state: RootState): CreateTeamStateProps => ({
  metrics: selectors.getMetrics(state),
  displayBanner: state.banner.displayBanner,
});

const mapDispatchToProperties = (
  dispatch: Dispatch
): CreateTeamDispatchProps => {
  return {
    setBanner: (banner: DisplayBanner | undefined) => {
      dispatch(bannerSlice.actions.setBanner(banner));
    },
  };
};

export default withRouter(
  connect(mapStateToProperties, mapDispatchToProperties)(CreateTeamPage)
);
